<div class="inspection-document">
    <div class="document-upload-section" *ngIf="canUpload">
        <h3>Por favor, suba el documento de inspección</h3>
        <div class="upload-area">
            <input #documentFileInput type="file" accept=".pdf,.jpg,.jpeg,.png" (change)="handleFileInput($event)"
                class="file-input" id="documentFileInput">
            <label for="documentFileInput" class="upload-label">
                <i class="fas fa-cloud-upload-alt"></i>
                <span>Seleccionar archivo</span>
                <small>Formatos permitidos: PDF, JPG, JPEG, PNG</small>
            </label>
        </div>

        <div class="selected-file" *ngIf="fileToUpload">
            <div class="file-info">
                <i [class]="getFileIcon()"></i>
                <span class="file-name">{{ fileToUpload.file.name }}</span>
            </div>
            <div class="file-actions">
                <button mat-icon-button color="primary" (click)="openImagePreview('toUpload')"
                    matTooltip="Vista previa">
                    <i class="fas fa-eye"></i>
                </button>
            </div>
        </div>
    </div>

    <div class="document-view-section" *ngIf="!canUpload">
        <h3>{{inspectionType === 'container' ? 'Inspección a las unidades de carga ' : 'Inspección preoperacional del
            vehículo'}}</h3>

        <div class="existing-document" *ngIf="uploadedFileUrl">
            <div class="document-info">
                <div class="document-details">
                    <i [class]="getExistingFileIcon()"></i>
                    <span class="document-name">{{ existingFileName }}</span>
                </div>
                <button mat-icon-button color="primary" (click)="openImagePreview('uploaded')" matTooltip="Ampliar">
                    <i class="fas fa-expand"></i>
                </button>
            </div>
            <div class="document-preview">
                <img *ngIf="existingDocumentType === 'image'" [src]="uploadedFileUrl | safe"
                    alt="Documento de inspección" class="preview-image" (error)="utils.onErrorRenderImage($event)">
                <embed *ngIf="existingDocumentType === 'pdf'" [src]="uploadedFileUrl | safe" type="application/pdf"
                    class="preview-pdf" (error)="onErrorRenderPdf($event)">
            </div>
        </div>
        <div class="no-document" *ngIf="!uploadedFileUrl">
            <i class="fas fa-file-alt"></i>
            <p>No hay documento de inspección disponible</p>
        </div>
    </div>
</div>